import axiosImport from "axios";

const axios = axiosImport.create({
  headers: {
    "q-bot-ui-token": localStorage.sessionToken,
  },
});

export default axios;
